import { FormGroup, Label, Input, Col } from "reactstrap";
import PropsType from "prop-types";

import ErrorMessageArray from "../../utils/ErrorMessageArray";

const CustomFormGroupRow = (props) => {
  const {
    label,
    name,
    onChange,
    type,
    value,
    placeholder,
    error,
    errorParam,
    required,
    options,
    disabled,
    className,
  } = props;
  return (
    <>
      {error && ErrorMessageArray(error, errorParam)}
      <FormGroup row className="align-items-center">
        <Label sm={4} className="text-center" md={2} for={name}>
          {label} {required && <span style={{ color: "red" }}>*</span>}
        </Label>
        <Col sm={8} md={10}>
          {type === "select" ? (
            <Input
              id={name}
              name="select"
              type="select"
              value={value}
              onChange={onChange}
              disabled={disabled}
              className={className}
            >
              {options?.map((op) => (
                <option key={op}>{op}</option>
              ))}
            </Input>
          ) : (
            <Input
              name={name}
              onChange={onChange}
              type={type}
              value={value}
              placeholder={placeholder}
              disabled={disabled}
              className={className}
            />
          )}
        </Col>
      </FormGroup>
    </>
  );
};

CustomFormGroupRow.propsTypes = {
  onChange: PropsType.func.isRequired,
  type: PropsType.string.isRequired,
  name: PropsType.string.isRequired,
};

export default CustomFormGroupRow;
